import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { Observable, throwError } from 'rxjs';
import { Order, OrderLine, OrdersService, Product } from '@vestiaire/api-sdk-angular';

import * as cartAction from '@app/core/cart/actions/cart.actions';

@Injectable()
export class CartService {
  constructor(private store: Store<IAppState>, private ordersService: OrdersService) {}

  /**
   * Refresh cart content.
   *
   * Call this method each time you want to reload cart from database.
   * eg. after adding or removing a product from cart.
   */
  refresh(): void {
    this.store.dispatch(new cartAction.LoadCart());
  }

  getCart(): Observable<Order> {
    return this.ordersService
      .getCart()
      .pipe(map(result => (result ? result.data : null)))
      .pipe(catchError(error => throwError(error)));
  }

  addToCart(product: Product): Observable<OrderLine> {
    return this.ordersService
      .addProductToCart({ idProduct: product.id })
      .pipe(map(result => result.data))
      .pipe(catchError(error => throwError(error)));
  }

  removeFromCart(item: OrderLine) {
    return this.ordersService.removeProductFromCart(item.id).pipe(catchError(error => throwError(error)));
  }
}
